import Rx from 'rxjs';
import AuthService from './auth.service';

export default class MasterService {
    constructor($http, host, AuthService){
        this.http = $http;
        this.host = host;
        this.auth = AuthService;
    }

    isMasterAccount(){
         return this.auth.parseJwt(this.auth.getAccountToken()).role == "MASTER";
    }

    getAdminAccounts(){
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: `${this.host}/api/master/accounts`
        }).then(
            resp => resp.data,
            resp => resp
        ));
    }

    createAdminAccount(data){
        return Rx.Observable.fromPromise(this.http({
            method: 'POST',
            url: `${this.host}/api/master/accounts`,
            data: data
        }).then(
            resp => resp.data,
            resp => resp
        ))
    }

}

MasterService.$inject = ['$http', 'host', 'AuthService'];


// WEBPACK FOOTER //
// ./src/app/services/master.service.js